import { Injectable } from '@angular/core';
import {
  Address,
  BankDetails,
  Contact,
  Enterprise,
  EnterpriseCotisation,
  EnterpriseStatistics,
} from '../models/models';
import { ApiService } from './api.service';
import { AppComponent } from '../app.component';

@Injectable({
  providedIn: 'root',
})
export class EnterpriseService {
  constructor(private apiService: ApiService) {}

  async getEnterprises(): Promise<Enterprise[]> {
    return new Promise(async (resolve, reject) => {
      this.apiService.get<Enterprise[]>('/enterprises', true).subscribe({
        next: (res) => {
          resolve(res.map((e) => new Enterprise(e)));
        },
        error: (res) => {
          console.log(res?.error);
          reject(res?.error);
        },
      });
    });
  }

  async getEnterprise(enterpriseId: string): Promise<Enterprise> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<Enterprise>('/enterprises/' + enterpriseId, true)
        .subscribe({
          next: (res) => {
            resolve(new Enterprise(res));
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  async getStats(enterpriseId: string): Promise<EnterpriseStatistics> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<EnterpriseStatistics>(
          '/enterprises/' + enterpriseId + '/statistics',
          true
        )
        .subscribe({
          next: (res) => {
            resolve(new EnterpriseStatistics(res));
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  async getBankDetails(enterpriseId: string): Promise<BankDetails> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<BankDetails>(
          '/enterprises/' + enterpriseId + '/bank-details',
          true
        )
        .subscribe({
          next: (res) => {
            resolve(new BankDetails(res));
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  async getAddresses(enterpriseId: string): Promise<Address[]> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<Address[]>('/enterprises/' + enterpriseId + '/addresses', true)
        .subscribe({
          next: (res) => {
            resolve(res.map((a) => new Address(a)));
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  async getContacts(enterpriseId: string): Promise<Contact[]> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<Contact[]>('/enterprises/' + enterpriseId + '/contacts', true)
        .subscribe({
          next: (res) => {
            resolve(res.map((c) => new Contact(c)));
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  async getContracts(enterpriseId: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<any>('/enterprises/' + enterpriseId + '/contracts', true)
        .subscribe({
          next: (res) => {
            resolve(res);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  async getCotisations() {
    const enterpriseId = AppComponent.enterprise.value.id;
    return new Promise<EnterpriseCotisation[]>(async (resolve, reject) => {
      this.apiService
        .get<EnterpriseCotisation[]>(
          '/enterprises/' + enterpriseId + '/cotisations',
          true
        )
        .subscribe({
          next: (res) => {
            resolve(res.map((c) => new EnterpriseCotisation(c)));
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  async downloadExportCotisations(
    year: number = null
  ): Promise<{ url: string }> {
    const enterpriseId = AppComponent.enterprise.value.id;
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<{ url: string }>(
          '/enterprises/' + enterpriseId + '/cotisations-export?year=' + year,
          true
        )
        .subscribe({
          next: (res) => {
            resolve(res);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  downloadPdfExportCotisations(cotisationId: string): Promise<{ url: string }> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<{ url: string }>(
          '/enterprises/' +
            AppComponent.enterprise.value.id +
            '/cotisations-export?cotisationId=' +
            cotisationId +
            '&format=pdf',
          true
        )
        .subscribe({
          next: (res) => {
            resolve(res);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  downloadExcelExportCotisations(
    cotisationId: string
  ): Promise<{ url: string }> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<{ url: string }>(
          '/enterprises/' +
            AppComponent.enterprise.value.id +
            '/cotisations-export?cotisationId=' +
            cotisationId +
            '&format=xlsx',
          true
        )
        .subscribe({
          next: (res) => {
            resolve(res);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }
}
